<section class="use-cases-section">
  <div class="background-gradient"></div>
  
  <div class="container">
    <div class="content-wrapper">
      <h2>Viral Postcard Campaigns</h2>
      
      <ul class="features-list">
        @for (feature of features; track feature; let i = $index) {
          <li class="feature-item">
            <div class="check-icon">
              <mat-icon>check</mat-icon>
            </div>
            <span>{{ feature }}</span>
          </li>
        }
      </ul>
    </div>
  </div>
</section>
